import { noop } from 'lodash'
import { DateFilterInputPropsType } from '../../../utils/types/tableFilterTypes'
import { useEffect, useRef, useState } from 'react'
import { filterOperatorValues } from '../../../utils'
import moment from 'moment'
import { SvgFunnel, SvgCross } from '../../../assets/images'
export const DateFilterInput = ({
  handleFilterChange = noop,
  search_key,
  filterObject,
  dataQaId,
  filterOperator,
  columnHeaderRef,
  innerInputRef,
  tabIndex,
}: DateFilterInputPropsType) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const datePickerRef = useRef<HTMLDivElement | null>(null)
  const openRef = useRef(false)
  const datePickerToRef = useRef<HTMLDivElement | null>(null)
  const openToRef = useRef(false)
  const inputToRef = useRef<HTMLInputElement | null>(null)
  const [inputValue, setInputValue] = useState<string>()
  const [inputToValue, setInputToValue] = useState<string>()
  const [isFilterApplied, setIsFilterApplied] = useState(false)
  const isRangeOperator = () => {
    return (
      filterOperator?.value === filterOperatorValues.BETWEEN ||
      filterOperator?.value === filterOperatorValues.NOT_BETWEEN
    )
  }

  const IsNullTypeOperator = () => {
    return (
      filterOperator?.value === filterOperatorValues.IS_NULL ||
      filterOperator?.value === filterOperatorValues.IS_NOT_NULL
    )
  }
  const handleClearFilterButtonClick = (index?: number) => {
    if (index === 1 && inputRef?.current?.value) {
      inputRef.current.value = ''
      setInputValue(inputRef?.current?.value)
    } else if (inputToRef?.current?.value) {
      inputToRef.current.value = ''
      setInputToValue(inputToRef?.current?.value)
    }
    handleFocusOut()
  }

  const onFilterChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e?.key === 'Enter') {
      ;(e.target as HTMLInputElement).blur()
    }
  }

  const handleFilterValueChange = (index?: number) => {
    if (index === 1) setInputValue(inputRef?.current?.value)
    else setInputToValue(inputToRef?.current?.value)
    if (openRef.current) {
      openRef.current = false
      handleFocusOut()
    } else if (openToRef.current) {
      openToRef.current = false
      handleFocusOut()
    }
  }

  const handleFocusOut = () => {
    if (openRef.current) openRef.current = false
    if (openToRef.current) openToRef.current = false
    inputRef.current?.blur()
    const searchInput: string[] = []
    if (inputRef?.current?.value) {
      const date = moment(inputRef.current.value)?.format('YYYY-MM-DD')
      searchInput.push(date)
    }
    if (isRangeOperator() && inputToRef?.current?.value) {
      const date = moment(inputToRef.current.value)?.format('YYYY-MM-DD')
      searchInput.push(date)
    }

    if (
      (!filterObject ||
        !search_key ||
        filterObject?.search_criteria?.[search_key]?.search_value?.[0] !==
          searchInput[0] ||
        filterObject?.search_criteria?.[search_key]?.search_value?.[1] !==
          searchInput[1] ||
        filterOperator?.value !==
          filterObject?.search_criteria?.[search_key]?.operator) &&
      (!isRangeOperator() || searchInput.length !== 1)
    ) {
      handleFilterChange({
        search_key: search_key,
        operator: filterOperator?.value ?? '',
        search_value: searchInput,
      })
    }
  }

  const handleDatePickerClick = (
    e: React.MouseEvent<HTMLInputElement, MouseEvent>,
    index: number
  ) => {
    const dateRef = index === 1 ? datePickerRef : datePickerToRef
    const openedRef = index === 1 ? openRef : openToRef
    if (dateRef.current) {
      const rect = dateRef.current.getBoundingClientRect()
      if (
        e.clientX >= rect.x &&
        e.clientX <= rect.x + rect.width &&
        e.clientY >= rect.y &&
        e.clientY <= rect.y + rect.height
      ) {
        openedRef.current = true
      }
    }
  }

  useEffect(() => {
    if (IsNullTypeOperator()) {
      if (inputRef.current) {
        inputRef.current.disabled = true
        inputRef.current.value = ''
        setInputValue('')
      }
      handleFilterChange({
        search_key: search_key,
        operator: filterOperator?.value ?? '',
        search_value: [''],
      })
    } else if (inputRef.current) inputRef.current.disabled = false
  }, [filterOperator])

  useEffect(() => {
    if (
      filterObject &&
      search_key &&
      filterObject?.search_criteria?.[search_key]
    ) {
      setIsFilterApplied(true)
    } else setIsFilterApplied(false)
  }, [filterObject])

  useEffect(() => {
    innerInputRef.current = inputRef.current
  }, [])

  useEffect(() => {
    const raw1 = filterObject?.search_criteria?.[search_key]?.search_value?.[0]
    const raw2 = filterObject?.search_criteria?.[search_key]?.search_value?.[1]

    const toInputValue = (val?: string) => {
      if (!val) return ''
      return moment(val).local().format('YYYY-MM-DD')
    }

    setInputValue(toInputValue(raw1))
    setInputToValue(toInputValue(raw2))
  }, [filterObject])

  return (
    <div
      className="flex items-center flex-1"
      onBlur={(e) => {
        if (
          !e.relatedTarget ||
          !columnHeaderRef.current?.contains(e.relatedTarget)
        )
          handleFocusOut()
      }}
    >
      <div className={`flex items-center relative flex-1`}>
        <SvgFunnel
          width={'16'}
          height={'16'}
          className={`mb-[1px] cursor-default ${
            isFilterApplied
              ? 'svg-path-fill-secondary'
              : 'svg-path-fill-accent-300'
          } absolute left-2`}
        />
        <input
          type={'date'}
          data-qa-id={`${dataQaId}_input_1`}
          className={`w-full border border-border-5 rounded-md focus:outline-none focus:border-secondary-500 hover:border-secondary-500 disabled:hover:border-border-5 text-xs font-light py-2 pl-8 pr-3`}
          ref={inputRef}
          onKeyDown={onFilterChange}
          onChange={() => handleFilterValueChange(1)}
          onFocus={() => (openRef.current = false)}
          onClick={(e) => {
            handleDatePickerClick(e, 1)
          }}
          value={inputValue}
          tabIndex={tabIndex}
        />
        <div
          className="h-[18px] w-[18px] absolute right-[13px] -z-10 opacity-0"
          ref={datePickerRef}
        />

        {inputValue || IsNullTypeOperator() ? (
          <SvgCross
            className={`svg-path-fill-secondary absolute right-[2.375rem] ${
              inputValue || IsNullTypeOperator() ? 'visible' : 'invisible'
            }`}
            width={'10'}
            height={'11'}
            onClick={() => handleClearFilterButtonClick(1)}
            tabIndex={-1}
          />
        ) : null}
      </div>
      {isRangeOperator() && (
        <>
          <div className="p-1 font-light">-</div>
          <div className="flex flex-1 items-center relative">
            <SvgFunnel
              width={'16'}
              height={'16'}
              className={`mb-[1px] cursor-default ${
                isFilterApplied
                  ? 'svg-path-fill-secondary'
                  : 'svg-path-fill-accent-300'
              } absolute left-2`}
            />
            <input
              type={'date'}
              data-qa-id={`${dataQaId}_input_2`}
              className="w-full border border-border-5 rounded-md focus:outline-none focus:border-secondary-500 hover:border-secondary-500 disabled:hover:border-border-5 text-xs font-light py-2 pl-8 pr-3"
              ref={inputToRef}
              onKeyDown={onFilterChange}
              onChange={() => handleFilterValueChange(2)}
              onFocus={() => (openToRef.current = false)}
              onClick={(e) => {
                handleDatePickerClick(e, 2)
              }}
              value={inputToValue}
            />
            <div
              className="h-[18px] w-[18px] absolute right-[13px] -z-10 opacity-0"
              ref={datePickerToRef}
            />
            {inputToValue ? (
              <SvgCross
                className={`svg-path-fill-secondary absolute right-[2.375rem]`}
                width={'10'}
                height={'11'}
                onClick={() => handleClearFilterButtonClick(2)}
                tabIndex={-1}
              />
            ) : null}
          </div>
        </>
      )}
    </div>
  )
}
